import { connect } from 'react-redux';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';

import { List as DictList, mapDispatchToProps } from '../../simple/List';

export class List extends DictList {
  constructor(props) {
    super(props);
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }
}

export default connect((state) =>
  ({
    refs: state.getIn(['references', 'simple', REF_PATH], new ImmutableList()),
  }),
mapDispatchToProps(REF_NAME, REF_PATH)
)(List);
